<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="跟单员accountId"
                clearable
                v-model="followerAccountId"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="交易员accountId"
                clearable
                v-model="leaderAccountId"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="cancel"
                placeholder="跟单状态"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in statusArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" @click="clearFiled">重置</el-button>
          </div>
          <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="500">
        <el-table-column
          label="跟单员用户id"
          prop="followerUserId"
          align="center"
        />

        <el-table-column
          label="交易员用户id"
          prop="leaderAccountId"
          align="center"
        />
        <el-table-column prop="" label="跟单员头像" align="center">
          <template slot-scope="scope">
            <img
              v-if="scope.row.avatar"
              :src="scope.row.avatar"
              alt=""
              class="avatar"
            />
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="跟随状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.cancel == 0">跟单中</span>
            <span v-if="scope.row.cancel == 1">已取消</span>
          </template>
        </el-table-column>

        <el-table-column
          label="累计跟随交易员人数"
          prop="followTraderAmount"
          align="center"
        />
        <el-table-column
          label="跟单员合约帐号"
          prop="followerAccountId"
          align="center"
        />
        <el-table-column
          label="累计跟随本金(usdt)"
          prop="followerMargin"
          align="center"
        />
        <el-table-column
          label="跟单员昵称"
          prop="followerNickname"
          align="center"
        />
        <el-table-column
          label="当前选择交易员"
          prop="leadersName"
          align="center"
        />
        <el-table-column label="亏损笔数" prop="lossCount" align="center" />
        <el-table-column label="盈利笔数" prop="profitCount" align="center" />
        <el-table-column
          label="总收益"
          prop="totalFollowProfit"
          align="center"
        />
        <el-table-column
          label="跟单总交易额"
          prop="totalFollowTrade"
          align="center"
        />
        <!-- <el-table-column label="操作员" prop="updater" align="center" /> -->
        <el-table-column label="总胜率" prop="winRate" align="center" />

        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </pagination>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      cancel: "",
      leaderAccountId: "",
      followerAccountId: "",
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      statusArr: [
        { label: "全部", value: "" },
        { label: "已取消", value: "1" },
        { label: "跟单中", value: "0" },
      ],
    };
  },
  computed: {},
  mounted() {
    this.handleSearch();
  },
  methods: {
    clearFiled() {
      this.followerAccountId = "";
      this.leaderAccountId = "";
      this.cancel = "";
      this.handleSearch({ page: 1 });
    },
    handleSearch(data = {}) {
      api
        .copytradeFollowList({
          cancel: this.cancel,
          followerAccountId: this.followerAccountId,
          leaderAccountId: this.leaderAccountId,
          ...this.pagination,
          ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            const { total, items } = res.data;
            this.tabList = items;
            this.totalCount = total;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style scoped lang="less">
.avatar {
  width: 50px;
  height: 50px;
}
</style>
